import Table from './Table';

export { default as FilterBar } from './FilterBar';
export default Table;
